import i18n from "i18next";
import { isContainedView, isSlide, isSortableBox, isSortableContainer } from "../../common/utils";
import { sceneHasQuestions, sceneHasOneClick } from "../../common/scene_mandatory";
import { toColor } from "../../common/common_tools";
import Select from "react-select";
import {
  FormLabel,
  Popover,
  FormControl,
  OverlayTrigger,
  Button,
  FormGroup,
  Accordion,
  FormCheck,
  InputGroup,
  Tooltip,
} from "react-bootstrap";
import RadioButtonFormGroup from "../../_editor/components/toolbar/radio_button_form_group/RadioButtonFormGroup";
import { UPDATE_PLUGIN_TOOLBAR } from "../../common/actions";
import ToggleSwitch from "@trendmicro/react-toggle-switch/lib/index";
import React from "react";
import FileInput from "../../_editor/components/common/file-input/FileInput";
import MarksList from "../../_editor/components/rich_plugins/marks_list/MarksList";
import ColorPicker from "../../_editor/components/common/color-picker/ColorPicker";
import LiveNumberInput from "../../_editor/components/common/LiveNumberInput";
import HoldRepeatButton from "../../_editor/components/common/HoldRepeatButton";
import { normalizeRotation, ROTATION_MIN, ROTATION_MAX } from "../../_editor/utils/rotation";
import ToolbarFileProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/ToolbarFileProvider";
import ApplyAllScenesProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/ApplyAllScenesProvider";
import AddSoundProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/AddSoundProvider";
import OneClickEditProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/OneClickEditProvider";
import ToolbarFileProviderWithoutInput from "../../_editor/components/external_provider/file_modal/APIProviders/common/ToolbarFileProviderWithoutInput";
import SoundListProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/SoundListProvider";
import AudioPlayerProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/AudioPlayerProvider";
import SoundRecorderProvider from "../../_editor/components/external_provider/file_modal/APIProviders/common/SoundRecorderProvider";
import Alert from "../../_editor/components/common/alert/Alert";

/* eslint-disable react/prop-types */

let mandatoryPopupState = {
  show: false,
  onClose: null,
  forceUpdate: null,
};

export function toolbarFiller(
  toolbar,
  id,
  state,
  config,
  initialParams,
  container,
  marks = null,
  exercises = {}
) {
  if (isSortableBox(id)) {
    toolbar.config.displayName = i18n.t("Container_");
  }
  if (!isSortableBox(id)) {
    createSizeButtons(toolbar, state, config, !isSortableBox(container), container);
    createAliasButton(toolbar, null);

    /* if(state.animation.startanimation.firstpositionx != "0" && state.animation.startanimation.firstpositiony != "0" && state.animation.endanimation.lastpositionx != "0" && state.animation.endanimation.lastpositiony != "0" ) */
    // createAnimationButtons(toolbar, state, config, !isSortableBox(container), container);
  }
  if (config && config.aspectRatioButtonConfig) {
    createAspectRatioButton(toolbar, config);
  }
  if (config && config.isRich) {
    createRichAccordions(toolbar);
  }

  if (config && config.category === "evaluation") {
    createScoreAccordions(toolbar, state, exercises);
  }
  return toolbar;
}

export function toolbarMapper(controls, toolbar) {
  /* if (Object.keys(toolbar.state).length > 0) {
        Object.keys(toolbar.state).forEach((s)=>{
            // avoid container ids
            if(s.indexOf("__") === -1 && (!!controls.main.accordions.basic && !!controls.main.accordions.basic.buttons && !!controls.main.accordions.basic.buttons[s])) {
                controls.main.accordions.basic.buttons[s].value = toolbar.state[s];
            }
        });
    }*/

  // console.log("controls,toolbar",controls,toolbar);

  if (Object.keys(toolbar.style).length > 0) {
    Object.keys(toolbar.style).forEach((s) => {
      if (controls.main.accordions.style.buttons[s]) {
        controls.main.accordions.style.buttons[s].value = toolbar.style[s];
      }
    });
  }
  if (Object.keys(toolbar.structure).length > 0) {
    Object.keys(toolbar.structure).forEach((s) => {
      if (
        s !== "width" &&
        s !== "height" &&
        s !== "heightUnit" &&
        s !== "widthUnit" &&
        s !== "aspectRatio"
      ) {
        if (controls.main.accordions.structure.buttons[s]) {
          controls.main.accordions.structure.buttons[s].value = toolbar.structure[s];
        }
      }
      if (s === "aspectRatio") {
        if (controls.main.accordions.structure.buttons[s]) {
          // Accept legacy `{checked:bool}` shape too.
          const v = toolbar.structure[s];
          controls.main.accordions.structure.buttons[s].checked =
            v === true || !!(v && v.checked === true);
        }
      }
    });
  }

  if (Object.keys(toolbar.position).length > 0) {
    Object.keys(toolbar.position).forEach((s) => {
      if (
        controls.main.accordions.structure.buttons[s] &&
        (s == "x" || s == "y") &&
        toolbar.position[s].toString().includes("%")
      ) {
        controls.main.accordions.structure.buttons[s].value = Number(
          toolbar.position[s].replace("%", "")
        );
      }
    });
  }

  /*
        if (Object.keys(toolbar.animation.startanimation).length > 0) {
            Object.keys(toolbar.animation.startanimation).forEach((s) => {

                    if (controls.main.accordions.animation.buttons[s] && (s == "firstpositionx" || s == "firstpositiony" || s == "firstwidth" || s == "firstheight") && toolbar.animation.startanimation[s].toString().includes("%")  ) {
                        controls.main.accordions.animation.buttons[s].value = Number(toolbar.animation.startanimation[s].replace("%",""));
                        controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                    }
                    else if(controls.main.accordions.animation.buttons[s]) {
                        controls.main.accordions.animation.buttons[s].value = toolbar.animation.startanimation[s];
                        controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                    }
            });
        }

        if (toolbar.animation.middleanimation != null && Object.keys(toolbar.animation.middleanimation).length > 0) {
            Object.keys(toolbar.animation.middleanimation).forEach((s) => {

                    if (controls.main.accordions.animation.buttons[s] && (s == "middlepositionx" || s == "middlepositiony" || s == "middlewidth" || s == "middleheight") && toolbar.animation.middleanimation[s].toString().includes("%")  ) {
                        controls.main.accordions.animation.buttons[s].value = Number(toolbar.animation.middleanimation[s].replace("%",""));
                        controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                    }
                    else if(controls.main.accordions.animation.buttons[s]) {
                        controls.main.accordions.animation.buttons[s].value = toolbar.animation.middleanimation[s];
                        controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                    }
            });
        }

        if (Object.keys(toolbar.animation.endanimation).length > 0) {
            Object.keys(toolbar.animation.endanimation).forEach((s) => {

                if (controls.main.accordions.animation.buttons[s] && (s == "lastpositionx" || s == "lastpositiony" || s == "lastwidth" || s == "lastheight") && toolbar.animation.endanimation[s].toString().includes("%") ) {
                    controls.main.accordions.animation.buttons[s].value = Number(toolbar.animation.endanimation[s].replace("%",""));
                    controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                }
                else if(controls.main.accordions.animation.buttons[s]) {
                    controls.main.accordions.animation.buttons[s].value = toolbar.animation.endanimation[s];
                    controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                }
            });
        }

        if (Object.keys(toolbar.animation.finalanimation).length > 0) {
            Object.keys(toolbar.animation.finalanimation).forEach((s) => {
                    if (controls.main.accordions.animation.buttons[s]  && s !== "showAnimation" && s !== "positionNumber") {
                        controls.main.accordions.animation.buttons[s].value = toolbar.animation.finalanimation[s];
                        controls.main.accordions.animation.buttons[s].hide = !toolbar.animation.finalanimation["showAnimation"];
                    }
                    else if(controls.main.accordions.animation.buttons[s]  && s === "positionNumber") {
                        controls.main.accordions.animation.buttons[s].value = toolbar.animation.finalanimation[s];
                    }
                    else if(controls.main.accordions.animation.buttons[s]  && s === "showAnimation") {
                        controls.main.accordions.animation.buttons[s].checked = toolbar.animation.finalanimation[s];
                    }
            });
        }*/

  return controls;
}

export function createRichAccordions(controls) {
  if (!controls.main) {
    controls.main = {
      __name: "Main",
      accordions: {
        __marks_list: {
          key: "marks_list",
          __name: i18n.t("marks.marks_list"),
          icon: "room",
          buttons: {},
        },
      },
    };
  }
  if (!controls.main.accordions.__marks_list) {
    controls.main.accordions.__marks_list = {
      key: "marks_list",
      __name: i18n.t("marks.marks_list"),
      icon: "room",
      buttons: {},
    };
  }
}

export function createScoreAccordions(controls = {}, state, exercises) {
  if (!controls.main) {
    controls.main = {
      __name: "Main",
      accordions: {},
    };
  }
  if (!controls.main.accordions.__score) {
    controls.main.accordions.__score = {
      key: "__score",
      __name: i18n.t("configuration"),
      icon: "build",
      buttons: {},
    };
  }
  let buttons = Object.assign({}, controls.main.accordions.__score.buttons || {}, {
    weight: {
      __name: i18n.t("Score"), // Valoración máxima (puntos)
      __defaultField: true,
      type: "number",
      value: exercises.weight,
      min: 0,
    },
  });

  controls.main.accordions.__score.buttons = buttons;
}

export function createAspectRatioButton(controls, config) {
  let arb = config.aspectRatioButtonConfig;
  let button = {
    __name: arb.name || i18n.t("AspectRatio"),
    type: "checkbox",
    checked: arb.defaultValue,
  };
  if (arb.location.length === 2) {
    controls[arb.location[0]].accordions[arb.location[1]].buttons.aspectRatio = button;
  } else {
    controls[arb.location[0]].accordions[arb.location[1]].accordions[
      arb.location[2]
    ].buttons.__aspectRatio = button;
  }
}

export function createControls(payload) {
  let controls = payload || {
    main: {
      __name: "Main",
      accordions: {},
    },
  };
}

export function createAliasButton(controls, state) {
  if (!controls.main) {
    controls.main = {
      __name: "Alias",
      icon: "rate_review",
      accordions: {
        z__extra: {
          __name: "Alias",
          buttons: {},
        },
      },
    };
  } else if (!controls.main.accordions.z__extra) {
    controls.main.accordions.z__extra = {
      __name: "Alias",
      icon: "rate_review",
      buttons: {},
    };
  }
  if (!controls.main.accordions.z__extra.buttons.alias) {
    if (state === null) {
      controls.main.accordions.z__extra.buttons.alias = {
        __name: "Alias",
        type: "text",
        value: "",
        isAttribute: true,
      };
    } else {
      controls.main.accordions.z__extra.buttons.alias = Object.assign(
        {},
        state.controls.main.accordions.z__extra.buttons.alias
      );
    }
  }
}

export function createSizeButtons(controls, state, initialParams, floatingBox, container) {
  if (!controls.main) {
    controls.main = {
      __name: "Main",
      accordions: {
        structure: {
          key: "structure",
          __name: i18n.t("Structure"),
          icon: "border_all",
          buttons: {},
        },
      },
    };
  } else if (!controls.main.accordions.structure) {
    controls.main.accordions.structure = {
      key: "structure",
      __name: i18n.t("Structure"),
      icon: "border_all",
      buttons: {},
    };
  }
  let displayValue;
  let value;
  let units;
  let type;

  // It means we are creating a new one, initial params can come
  // if (state === null) {
  if (floatingBox) {
    displayValue = 25;
    value = 25;
    units = "%";
  } else {
    displayValue = 25;
    value = 25;
    units = "%";
  }
  type = "number";

  if (isSortableContainer(container) && isSortableBox(parent) && config.needsTextEdition) {
    displayValue = 25;
    value = 25;
    units = "%";
  }

  let initialWidth = initialParams.initialWidth;
  if (initialWidth) {
    if (initialWidth === "auto") {
      displayValue = "auto";
      units = "%";
      type = "text";
    } else {
      displayValue = parseInt(initialWidth, 10);
      value = parseInt(initialWidth, 10);
      if (initialWidth.indexOf("px") !== -1) {
        units = "px";
      } else {
        units = "%";
      }
    }
  }

  /* } else {
        let width = controls.main.accordions.__sortable.buttons.__width;
        displayValue = width.displayValue;
        value = width.value;
        units = width.units;
        type = width.type;
    }*/
  controls.main.accordions.structure.buttons.width = {
    __name: i18n.t("Width"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 5,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };
  // if (state === null) {
  let initialHeight = initialParams.initialHeight;
  if (initialHeight) {
    if (initialHeight === "auto") {
      displayValue = "auto";
      units = "%";
      type = "text";
    } else {
      displayValue = parseInt(initialHeight, 10);
      value = parseInt(initialHeight, 10);
      if (initialHeight.indexOf("px") !== -1) {
        units = "px";
      } else {
        units = "%";
      }
    }
  } else {
    value = "20";
    displayValue = "auto";
    units = "%";
    type = "text";
  }

  /* } else {
        let height = state.controls.main.accordions.__sortable.buttons.__height;
        type = height.type;
        displayValue = height.displayValue;
        value = height.value;
        units = height.units;
    }*/
  controls.main.accordions.structure.buttons.height = {
    __name: i18n.t("Height"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 5,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.structure.buttons.x = {
    __name: i18n.t("Animation.PositionX"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 5,
    units: units,
    min: 0,
    max: 100,
  };

  controls.main.accordions.structure.buttons.y = {
    __name: i18n.t("Animation.PositionY"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 5,
    units: units,
    min: 0,
    max: 100,
  };

  controls.main.accordions.structure.buttons.rotation = {
    __name: i18n.t("Rotate"),
    type: "range",
    value: 0,
    min: ROTATION_MIN,
    max: ROTATION_MAX,
  };

  controls.main.accordions.structure.buttons.horizontalFlip = {
    __name: i18n.t("HorizontalFlip"),
    type: "checkbox",
    checked: state.structure.horizontalFlip,
  };

  controls.main.accordions.structure.buttons.verticalFlip = {
    __name: i18n.t("VerticalFlip"),
    type: "checkbox",
    checked: state.structure.verticalFlip,
  };

  controls.main.accordions.structure.buttons.isContentElement = {
    __name: "AI Element?",
    type: "checkbox",
    checked: state.structure.isContentElement,
  };

  // This will be commented until it's working correctly
  if (!floatingBox) {
    /* controls.main.accordions.structure.buttons.position = {
            __name: i18n.t('Position'),
            type: 'radio',
            value: 'relative',
            options: ['absolute', 'relative'],

        };*/
  } else {
    // let hasPositionButton = action.payload.toolbar && action.payload.toolbar.main && action.payload.toolbar.main.accordions && action.payload.toolbar.main.accordions.__sortable && action.payload.toolbar.main.accordions.__sortable.buttons && action.payload.toolbar.main.accordions.__sortable.buttons.__position;
    let hasPositionButton =
      state.controls &&
      state.controls.main &&
      state.controls.main.accordions &&
      state.controls.main.accordions.structure &&
      state.controls.main.accordions.structure.buttons &&
      state.controls.main.accordions.structure.buttons.__position;

    if (floatingBox && hasPositionButton) {
      controls.main.accordions.structure.buttons.position = {
        __name: i18n.t("Position"),
        type: "radio",
        value: state.controls.main.accordions.structure.buttons.position.value,
        options: ["absolute", "relative"],
      };
    }
  }
}

export function createAnimationButtons(controls, state, initialParams, floatingBox, container) {
  if (!controls.main) {
    controls.main = {
      __name: "Main",
      accordions: {
        animation: {
          key: "animation",
          __name: IdealStudio.i18n.t("Animation.Animation"),
          icon: "border_all",
          buttons: {},
        },
      },
    };
  } else if (!controls.main.accordions.animation) {
    controls.main.accordions.animation = {
      key: "animation",
      __name: IdealStudio.i18n.t("Animation.Animation"),
      icon: "border_all",
      buttons: {},
    };
  }

  let displayValue;
  let value;
  let units;
  let type;

  if (floatingBox) {
    displayValue = 25;
    value = 25;
    units = "%";
  } else {
    displayValue = 25;
    value = 25;
    units = "%";
  }
  type = "number";

  if (isSortableContainer(container) && isSortableBox(parent) && config.needsTextEdition) {
    displayValue = 25;
    value = 25;
    units = "%";
  }

  let initialWidth = initialParams.initialWidth;
  if (initialWidth) {
    if (initialWidth === "auto") {
      displayValue = "auto";
      units = "%";
      type = "text";
    } else {
      displayValue = parseInt(initialWidth, 10);
      value = parseInt(initialWidth, 10);
      if (initialWidth.indexOf("px") !== -1) {
        units = "px";
      } else {
        units = "%";
      }
    }
  }

  let initialHeight = initialParams.initialHeight;
  if (initialHeight) {
    if (initialHeight === "auto") {
      displayValue = "auto";
      units = "%";
      type = "number";
    } else {
      displayValue = parseInt(initialHeight, 10);
      value = parseInt(initialHeight, 10);
      if (initialHeight.indexOf("px") !== -1) {
        units = "px";
      } else {
        units = "%";
      }
    }
  } else {
    value = "20";
    displayValue = "auto";
    units = "%";
    type = "number";
  }

  controls.main.accordions.animation.buttons.positionNumber = {
    __name: i18n.t("Animation.PositionNumber"),
    type: "radio",
    value: value,
    options: [2, 3],
  };

  controls.main.accordions.animation.buttons.showAnimation = {
    __name: i18n.t("Animation.ShowAnimation"),
    type: "checkbox",
    checked: value,
  };

  controls.main.accordions.animation.buttons.firstpositionx = {
    __name: i18n.t("Animation.FirstPositionX") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.firstpositiony = {
    __name: i18n.t("Animation.FirstPositionY") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.middlepositionx = {
    __name: i18n.t("Animation.MiddlePositionX") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.middlepositiony = {
    __name: i18n.t("Animation.MiddlePositionY") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.lastpositionx = {
    __name: i18n.t("Animation.LastPositionX") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.lastpositiony = {
    __name: i18n.t("Animation.LastPositionY") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.firstwidth = {
    __name: i18n.t("Animation.Firstwidth") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.firstheight = {
    __name: i18n.t("Animation.FirstHeight") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.middlewidth = {
    __name: i18n.t("Animation.Middlewidth") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.middleheight = {
    __name: i18n.t("Animation.MiddleHeight") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.lastwidth = {
    __name: i18n.t("Animation.Lastwidth") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.lastheight = {
    __name: i18n.t("Animation.LastHeight") + " (%)",
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: units === "%" ? 100 : 100000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.firstopacity = {
    __name: i18n.t("Animation.FirstOpacity"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: 1,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.middleopacity = {
    __name: i18n.t("Animation.MiddleOpacity"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: 1,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.lastopacity = {
    __name: i18n.t("Animation.LastOpacity"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 0.1,
    units: units,
    min: 0,
    max: 1,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.firstduration = {
    __name: i18n.t("Animation.FirstDuration"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 1,
    units: units,
    min: 0,
    max: 1000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.middleduration = {
    __name: i18n.t("Animation.MiddleDuration"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 1,
    units: units,
    min: 0,
    max: 1000,
    auto: displayValue === "auto",
  };

  controls.main.accordions.animation.buttons.lastduration = {
    __name: i18n.t("Animation.LastDuration"),
    type: type,
    displayValue: displayValue,
    value: value,
    step: 1,
    units: units,
    min: 0,
    max: 1000,
    auto: displayValue === "auto",
  };
}

// Single toggle that replaces the pair of per-axis "auto" switches under width/height.
function renderUnifiedAspectRatioToggle(toolbar_props, key) {
  const id = toolbar_props.boxSelected;
  if (id === -1 || id === undefined) return null;
  const tps = toolbar_props.pluginToolbars && toolbar_props.pluginToolbars[id];
  if (!tps || !tps.structure) return null;

  const rawAR = tps.structure.aspectRatio;
  const checked = rawAR === true || !!(rawAR && rawAR.checked === true);

  const onChange = () => {
    // Lock → height "auto" (width stays editable); unlock → restore stashed height.
    const next = { aspectRatio: !checked };
    if (!checked) {
      if (tps.structure.height !== "auto") {
        next.__heightBeforeAuto = tps.structure.height;
        next.__heightUnitBeforeAuto = tps.structure.heightUnit;
      }
      next.height = "auto";
    } else if (tps.structure.height === "auto") {
      const prev = tps.structure.__heightBeforeAuto;
      next.height = typeof prev === "number" ? prev : 44;
      next.heightUnit = tps.structure.__heightUnitBeforeAuto || "%";
    }
    toolbar_props.onBoxResized(id, next);
  };

  return (
    <OverlayTrigger
      key={key}
      placement="top"
      overlay={<Tooltip id="aspectRatioLockHint">{i18n.t("AspectRatioLockHint")}</Tooltip>}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
          width: "100%",
          marginTop: "10px",
          padding: "8px 12px",
          background: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "10px",
          boxSizing: "border-box",
        }}
      >
        <label
          style={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#334155",
            margin: 0,
            flex: 1,
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={onChange}
        >
          {i18n.t("AspectRatioLock")}
        </label>
        <div className="custom-toggle-wrapper" style={{ flexShrink: 0 }}>
          <ToggleSwitch checked={checked} onChange={onChange} />
        </div>
      </div>
    </OverlayTrigger>
  );
}

/**
 * Render toolbar accordion
 * @param accordion Name of the accordion
 * @param tabKey Unique key of the tab
 * @param accordionKeys Unique keys of the accordion
 * @param state Toolbar state
 * @param key Current key
 */
export function renderAccordion(accordion, tabKey, accordionKeys, state, key, toolbar_props) {
  if (!accordion) {
    return null;
  }

  if (accordionKeys[0] === "z__extra") {
    return null;
  }

  // İşaretçi Listesi, Ayarlar panelinden gizlendi — artık Araçlar (ToolsPanel)
  // içinde bir araç olarak render ediliyor. Accordion oluşturma kodu (createRich-
  // Accordions) ve aşağıdaki MarksList render bloğu bilerek korundu.
  if (accordion.key === "marks_list") {
    return null;
  }

  let props = {
    key: key,
    className: "panelPluginToolbar",
    header: (
      <div key={"span" + key} className={"panel-heading"}>
        <p className={"titleA"}>{accordion.__name}</p>
      </div>
    ),
  };
  let children = [];
  if (accordion.order) {
    for (let i = 0; i < accordion.order.length; i++) {
      if (accordion.accordions[accordion.order[i]]) {
        children.push(
          renderAccordion(
            accordion.accordions[accordion.order[i]],
            tabKey,
            [accordionKeys[0], accordion.order[i]],
            state,
            `accordion_${accordion.order[i]}_${i}`
          )
        );
      } else if (accordion.buttons[accordion.order[i]]) {
        children.push(
          <div key={`button_${accordion.order[i]}_${i}`}>
            {renderButton(
              accordion,
              tabKey,
              accordionKeys,
              accordion.order[i],
              state,
              i,
              toolbar_props
            )}
          </div>
        );
        if (
          (accordion.order[i] === "height" || accordion.order[i] === "__height") &&
          accordionKeys[0] === "structure" &&
          accordion.buttons.width &&
          toolbar_props
        ) {
          children.push(renderUnifiedAspectRatioToggle(toolbar_props, `ar_toggle_${i}`));
        }
      } else {
        // eslint-disable-next-line no-console
        console.error("Element %s not defined", accordion.order[i]);
      }
    }
  } else {
    let buttonKeys = Object.keys(accordion.buttons);
    for (let i = 0; i < buttonKeys.length; i++) {
      const isWidthOrHeight =
        buttonKeys[i] === "width" ||
        buttonKeys[i] === "height" ||
        buttonKeys[i] === "__width" ||
        buttonKeys[i] === "__height";
      let buttonWidth = isWidthOrHeight ? "50%" : "100%";
      let buttonMargin = isWidthOrHeight ? "0px" : "0px";
      const isHiddenButton = !!accordion.buttons[buttonKeys[i]].hide;
      children.push(
        <div
          key={`div_${buttonKeys[i]}_${i}`}
          style={{
            display: isHiddenButton ? "none" : undefined,
            width: buttonWidth,
            marginRight: buttonMargin,
            marginTop: "8px",
            boxSizing: "border-box",
            paddingRight: isWidthOrHeight ? "6px" : "0px",
          }}
        >
          {renderButton(accordion, tabKey, accordionKeys, buttonKeys[i], state, i, toolbar_props)}
        </div>
      );
      if (
        (buttonKeys[i] === "height" || buttonKeys[i] === "__height") &&
        accordionKeys[0] === "structure" &&
        accordion.buttons.width &&
        toolbar_props
      ) {
        children.push(renderUnifiedAspectRatioToggle(toolbar_props, `ar_toggle_${i}`));
      }
    }
  }

  if (accordion.key === "marks_list") {
    children.push(
      <MarksList
        key="marks_list"
        state={toolbar_props.marks}
        viewToolbars={toolbar_props.viewToolbars}
        box_id={toolbar_props.box.id}
        onRichMarksModalToggled={toolbar_props.onRichMarksModalToggled}
        onRichMarkEditPressed={toolbar_props.onRichMarkEditPressed}
        onRichMarkDeleted={toolbar_props.onRichMarkDeleted}
      />
    );
  }

  return (
    <Accordion.Item key={key} className={"panelPluginToolbar"} eventKey={key}>
      <Accordion.Header>{props.header}</Accordion.Header>
      <Accordion.Body>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start" }}>
          {children}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );

  // React.createElement(Panel, props, children);
}

/**
 * Render toolbar button
 * @param accordion Name of the accordion
 * @param tabKey Unique key of the tab
 * @param accordionKeys Unique keys of the accordion
 * @param buttonKey Unique key of the button
 * @param state Toolbar state
 * @param key Current key
 * @returns {code} Button code
 */
/**
 * Controlled number input that only APPLIES its value on blur / Enter (not on
 * every keystroke). While focused it keeps a local draft string, so the user
 * can type freely without the value being clamped or dispatched mid-typing
 * (which used to churn state — e.g. re-creating answer boxes on each key — and
 * made "1" jump to "6" when typing "12"). Selecting the text on focus lets a
 * fresh keypress replace the value instead of appending to it.
 */
function NumberField(props) {
  const { value, min, max, step, placeholder, style, onCommit, allowEmpty } = props;
  const toStr = (v) => (v === undefined || v === null ? "" : String(v));
  const [draft, setDraft] = React.useState(toStr(value));

  React.useEffect(() => {
    setDraft(toStr(value));
  }, [value]);

  const commit = () => {
    // Empty is a valid value here: clear the field instead of sticking at 0.
    if (allowEmpty && !(parseFloat(draft) > 0)) {
      setDraft("");
      if (toStr(value) !== "") onCommit("");
      return;
    }
    let v = parseFloat(draft);
    if (isNaN(v)) v = min !== undefined ? min : 0;
    if (max !== undefined && v > max) v = max;
    if (min !== undefined && v < min) v = min;
    setDraft(toStr(v));
    if (v !== value) onCommit(v);
  };

  return (
    <input
      type="number"
      value={draft}
      placeholder={placeholder || ""}
      min={min}
      max={max}
      step={step || 1}
      style={style}
      onFocus={(e) => e.target.select()}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.target.blur();
        } else if (e.key === "Escape") {
          setDraft(toStr(value));
          e.target.blur();
        }
      }}
    />
  );
}

export function renderButton(
  accordion,
  tabKey,
  accordionKeys,
  buttonKey,
  state,
  key,
  toolbar_props
) {
  let button = accordion.buttons[buttonKey];
  let children = null;

  let id =
    toolbar_props.boxSelected !== -1
      ? toolbar_props.boxSelected
      : toolbar_props.containedViewSelected !== 0
        ? toolbar_props.containedViewSelected
        : toolbar_props.navItemSelected;

  const queryParams = new URLSearchParams(window?.location?.search);
  const hasTemplateId = queryParams?.has("id");
  const isTemplateView = queryParams?.get("template") === "true";

  if (buttonKey === "isContentElement" && (!hasTemplateId || !isTemplateView)) {
    return <></>;
  }

  // horizontalFlip and verticalFlip are rendered together inside the rotation block
  if (
    accordionKeys[0] === "structure" &&
    (buttonKey === "horizontalFlip" || buttonKey === "verticalFlip")
  ) {
    return null;
  }

  // Owned by the unified toggle / structure panel injections below.
  if (
    accordionKeys[0] === "structure" &&
    (buttonKey === "aspectRatio" || buttonKey === "__aspectRatio")
  ) {
    return null;
  }
  if (buttonKey === "allowDeformed") {
    return null;
  }

  // Shared styles for 4-cell controls (padding & borderRadius)
  const _4cellSectionTitleStyle = {
    fontSize: "11px",
    fontWeight: 600,
    color: "#64748b",
    marginBottom: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  };
  const _4cellSubLabelStyle = {
    fontSize: "10px",
    fontWeight: 600,
    color: "#94a3b8",
    marginBottom: "3px",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  };
  const _4cellBoxStyle = {
    display: "flex",
    alignItems: "center",
    background: "#f1f5f9",
    borderRadius: "8px",
    padding: "5px 10px",
    border: "1px solid #e2e8f0",
    flex: 1,
    minWidth: 0,
  };
  const _4cellInputStyle = {
    flex: 1,
    border: "none",
    background: "transparent",
    fontWeight: 600,
    fontSize: "14px",
    color: "#1e293b",
    width: "100%",
    outline: "none",
    textAlign: "right",
    minWidth: 0,
  };
  const _4cellUnitStyle = { fontSize: "11px", color: "#94a3b8", marginLeft: "2px", flexShrink: 0 };

  const make4CellInput = (cssKey, label, val, min, max, onDispatch) => (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={_4cellSubLabelStyle}>{label}</div>
      <div style={_4cellBoxStyle}>
        <input
          type="number"
          value={val}
          min={min}
          max={max}
          step={1}
          style={_4cellInputStyle}
          onChange={(e) => {
            const v = e.target.value === "" ? 0 : Number(e.target.value);
            onDispatch(cssKey, v);
          }}
        />
        <span style={_4cellUnitStyle}>px</span>
      </div>
    </div>
  );

  // Padding — render as 4 independent side inputs (Left / Right / Top / Bottom)
  if (accordionKeys[0] === "style" && buttonKey === "padding") {
    const _ps =
      toolbar_props.boxSelected !== -1
        ? toolbar_props.pluginToolbars[toolbar_props.boxSelected]
        : null;
    const styleState = _ps && _ps.style ? _ps.style : {};
    const fallback =
      styleState.padding !== undefined
        ? styleState.padding
        : button.value !== undefined
          ? button.value
          : 0;
    const pLeft = styleState.paddingLeft !== undefined ? styleState.paddingLeft : fallback;
    const pRight = styleState.paddingRight !== undefined ? styleState.paddingRight : fallback;
    const pTop = styleState.paddingTop !== undefined ? styleState.paddingTop : fallback;
    const pBottom = styleState.paddingBottom !== undefined ? styleState.paddingBottom : fallback;
    const dispatch = (cssKey, v) => toolbar_props.onToolbarUpdated(id, tabKey, "style", cssKey, v);
    const min = button.min !== undefined ? button.min : 0;
    const max = button.max !== undefined ? button.max : 100;

    return (
      <div
        key="padding-4-sides"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          marginBottom: "4px",
        }}
      >
        <div style={_4cellSectionTitleStyle}>{button.__name}</div>
        <div style={{ display: "flex", gap: "8px" }}>
          {make4CellInput("paddingLeft", i18n.t("Left") || "Left", pLeft, min, max, dispatch)}
          {make4CellInput("paddingRight", i18n.t("Right") || "Right", pRight, min, max, dispatch)}
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          {make4CellInput("paddingTop", i18n.t("Top") || "Top", pTop, min, max, dispatch)}
          {make4CellInput(
            "paddingBottom",
            i18n.t("Bottom") || "Bottom",
            pBottom,
            min,
            max,
            dispatch
          )}
        </div>
      </div>
    );
  }

  // borderRadius — render as 4 independent corner inputs (TL / TR / BL / BR)
  if (accordionKeys[0] === "style" && buttonKey === "borderRadius") {
    const _ps =
      toolbar_props.boxSelected !== -1
        ? toolbar_props.pluginToolbars[toolbar_props.boxSelected]
        : null;
    const styleState = _ps && _ps.style ? _ps.style : {};
    const fallback =
      styleState.borderRadius !== undefined
        ? styleState.borderRadius
        : button.value !== undefined
          ? button.value
          : 0;
    const rTL =
      styleState.borderTopLeftRadius !== undefined ? styleState.borderTopLeftRadius : fallback;
    const rTR =
      styleState.borderTopRightRadius !== undefined ? styleState.borderTopRightRadius : fallback;
    const rBL =
      styleState.borderBottomLeftRadius !== undefined
        ? styleState.borderBottomLeftRadius
        : fallback;
    const rBR =
      styleState.borderBottomRightRadius !== undefined
        ? styleState.borderBottomRightRadius
        : fallback;
    const dispatch = (cssKey, v) => toolbar_props.onToolbarUpdated(id, tabKey, "style", cssKey, v);
    const min = button.min !== undefined ? button.min : 0;
    const max = button.max !== undefined ? button.max : 100;

    return (
      <div
        key="borderRadius-4-corners"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          marginBottom: "4px",
        }}
      >
        <div style={_4cellSectionTitleStyle}>{button.__name}</div>
        <div style={{ display: "flex", gap: "8px" }}>
          {make4CellInput("borderTopLeftRadius", "TL", rTL, min, max, dispatch)}
          {make4CellInput("borderTopRightRadius", "TR", rTR, min, max, dispatch)}
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          {make4CellInput("borderBottomLeftRadius", "BL", rBL, min, max, dispatch)}
          {make4CellInput("borderBottomRightRadius", "BR", rBR, min, max, dispatch)}
        </div>
      </div>
    );
  }

  /* let currentElement = (accordionKeys[0] === "basic") ? "state" :
        accordionKeys[0];*/
  let currentElement =
    [
      "structure",
      "style",
      "z__extra",
      "__marks_list",
      "__score",
      "__inputStyle",
      "animation",
    ].indexOf(accordionKeys[0]) === -1
      ? "state"
      : accordionKeys[0];
  // get toolbar
  let toolbar_plugin_state;
  if (toolbar_props.boxSelected !== -1) {
    toolbar_plugin_state = toolbar_props.pluginToolbars[toolbar_props.boxSelected];
  }
  let props = {
    key: "child_" + key,
    id: "page" + "_" + buttonKey,
    type: button.type,
    value: button.value,
    checked: button.checked,
    label: button.__name,
    min: button.min,
    max: button.max,
    step: button.step,
    disabled: false,
    placeholder: button.placeholder,
    title: button.title ? button.title : "",
    className: button.class,
    style: { width: "100%" },
    onBlur: (e) => {
      let value = e.target.value;
      if (button.type === "number" && value === "") {
        value = button.min ? button.min : 0;
      }
    },
    onChange: (e) => {
      let value;
      if (typeof e.target !== "undefined") {
        value = e.target.value;
        if (e.target.type === "number" && e.target.value === "" && e.target.min) {
          value = e.target.min;
        }
      } else {
        value = e.value;
      }

      if (
        currentElement === "structure" &&
        (buttonKey === "width" || buttonKey === "height" || buttonKey === "x" || buttonKey === "y")
      ) {
        let type = e.target.type;
        if (!type && e.target.classList.contains("toggle-switch---toggle---mncCu")) {
          type = "checkbox";
        }
        switch (type) {
          case "checkbox":
            if (buttonKey === "aspectRatio") {
              const rawAR = toolbar_plugin_state.structure.aspectRatio;
              const currentlyOn = rawAR === true || (rawAR && rawAR.checked === true);
              const next = { aspectRatio: !currentlyOn };
              if (!currentlyOn) {
                if (toolbar_plugin_state.structure.height !== "auto") {
                  next.__heightBeforeAuto = toolbar_plugin_state.structure.height;
                  next.__heightUnitBeforeAuto = toolbar_plugin_state.structure.heightUnit;
                }
                next.height = "auto";
              } else if (toolbar_plugin_state.structure.height === "auto") {
                const prev = toolbar_plugin_state.structure.__heightBeforeAuto;
                next.height = typeof prev === "number" ? prev : 44;
                next.heightUnit = toolbar_plugin_state.structure.__heightUnitBeforeAuto || "%";
              }
              toolbar_props.onBoxResized(id, next);
            } else {
              toolbar_props.onBoxResized(id, {
                [buttonKey]: toolbar_plugin_state.structure[buttonKey] === "auto" ? 100 : "auto",
              });
            }
            break;
          case "select-one":
            toolbar_props.onBoxResized(id, { [buttonKey + "Unit"]: value });
            break;

          default:
            if (isNaN(parseInt(value, 10))) {
              if (value === "") {
                value = 0;
              } else {
                value = 100;
              }
            } else {
              value = parseInt(value, 10);
            }
            if (toolbar_plugin_state.structure[buttonKey + "Unit"] === "%") {
              value = Math.min(Math.max(value, 0), 100);
            } else if (toolbar_plugin_state.structure[buttonKey + "Unit"] === "px") {
              value = Math.max(value, 0);
            }

            let otherButton = buttonKey === "width" ? "height" : "width";
            if (toolbar_plugin_state.structure.aspectRatio) {
              let otherValue = (
                (toolbar_plugin_state.structure[otherButton] * value) /
                toolbar_plugin_state.structure[buttonKey]
              ).toFixed(3);
              if (
                toolbar_plugin_state.structure[otherButton] !== "auto" &&
                buttonKey != "x" &&
                buttonKey != "y"
              ) {
                if (
                  (toolbar_plugin_state.structure[buttonKey + "Unit"] === "%" && value > 100) ||
                  (toolbar_plugin_state.structure[otherButton + "Unit"] === "%" && otherValue > 100)
                ) {
                  return;
                }

                toolbar_props.onBoxResized(id, {
                  [buttonKey]: value,
                  [otherButton]: otherValue,
                });
              }
            }

            // If next values are going to be over 100%, prevent action
            if (
              (toolbar_plugin_state.structure[buttonKey] !== "auto" &&
                toolbar_plugin_state.structure[buttonKey + "Unit"] === "%" &&
                value > 100) ||
              (toolbar_plugin_state.structure[otherButton + "Unit"] === "%" &&
                toolbar_plugin_state.structure[otherButton] > 100)
            ) {
              return;
            }

            if (buttonKey === "width") {
              toolbar_props.onBoxResized(id, { width: value });
            }

            if (buttonKey === "height") {
              toolbar_props.onBoxResized(id, { height: value });
            }

            if (buttonKey === "x") {
              toolbar_props.onBoxMoved(
                id,
                Math.min(value, 100 - toolbar_plugin_state.structure.width) + "%",
                toolbar_props.box.position.y,
                "absolute",
                toolbar_props.box.parent,
                toolbar_props.box.container
              );
            }

            if (buttonKey === "y") {
              toolbar_props.onBoxMoved(
                id,
                toolbar_props.box.position.x,
                Math.min(value, 100 - toolbar_plugin_state.structure.height) + "%",
                "absolute",
                toolbar_props.box.parent,
                toolbar_props.box.container
              );
            }

            return;
        }

        return;
      }

      if (currentElement === "animation") {
        let type = e.target.type;
        if (!type && e.target.classList.contains("toggle-switch---toggle---mncCu")) {
          type = "checkbox";
        }

        /* if(buttonKey != 'firstOpacity' && buttonKey != 'lastOpacity')
                {
                    if (isNaN(parseInt(value, 10))) {
                        if (value === "") {
                            value = 0;
                        } else {
                            value = 100;
                        }
                    } else {
                        value = parseInt(value, 10);
                    }
                } */

        if (buttonKey === "positionNumber") {
          toolbar_props.onBoxAnimationPositionNumber(
            id,
            button.options[value],
            toolbar_props.box.parent,
            toolbar_props.box.container
          );
        }

        if (buttonKey === "showAnimation") {
          value = !button.checked;
          toolbar_props.onBoxShowAnimation(
            id,
            value,
            toolbar_props.box.parent,
            toolbar_props.box.container
          );
        }

        if (toolbar_plugin_state.animation[buttonKey + "Unit"] === "%") {
          value = Math.min(Math.max(value, 0), 100);
        } else if (toolbar_plugin_state.animation[buttonKey + "Unit"] === "px") {
          value = Math.max(value, 0);
        }

        let otherButton = buttonKey === "width" ? "height" : "width";

        // If next values are going to be over 100%, prevent action
        if (
          (toolbar_plugin_state.animation[buttonKey] !== "auto" &&
            toolbar_plugin_state.animation[buttonKey + "Unit"] === "%" &&
            value > 100) ||
          (toolbar_plugin_state.animation[otherButton + "Unit"] === "%" &&
            toolbar_plugin_state.animation[otherButton] > 100)
        ) {
          return;
        }

        /*
                    if (buttonKey === "firstpositionx") {
                        toolbar_props.onBoxStartAnimation(id,value + "%",toolbar_props.box.startanimation.firstpositiony,toolbar_props.box.startanimation.firstwidth,
                        toolbar_props.box.startanimation.firstheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "firstpositiony") {
                        toolbar_props.onBoxStartAnimation(id,toolbar_props.box.startanimation.firstpositionx,value + "%",toolbar_props.box.startanimation.firstwidth,
                        toolbar_props.box.startanimation.firstheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "firstwidth") {
                        toolbar_props.onBoxStartAnimation(id,toolbar_props.box.startanimation.firstpositionx,toolbar_props.box.startanimation.firstpositiony,value + "%",
                        toolbar_props.box.startanimation.firstheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "firstheight") {
                        toolbar_props.onBoxStartAnimation(id,toolbar_props.box.startanimation.firstpositionx,toolbar_props.box.startanimation.firstpositiony,
                            toolbar_props.box.startanimation.firstwidth,value + "%",toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "middlepositionx") {
                        toolbar_props.onBoxMiddleAnimation(id,value + "%",toolbar_props.box.middleanimation.middlepositiony,toolbar_props.box.middleanimation.middlewidth,
                        toolbar_props.box.middleanimation.middleheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "middlepositiony") {
                        toolbar_props.onBoxMiddleAnimation(id,toolbar_props.box.middleanimation.middlepositionx,value + "%",toolbar_props.box.middleanimation.middlewidth,
                        toolbar_props.box.middleanimation.middleheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "middlewidth") {
                        toolbar_props.onBoxMiddleAnimation(id,toolbar_props.box.middleanimation.middlepositionx,toolbar_props.box.middleanimation.middlepositiony,value + "%",
                        toolbar_props.box.middleanimation.middleheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "middleheight") {
                        toolbar_props.onBoxMiddleAnimation(id,toolbar_props.box.middleanimation.middlepositionx,toolbar_props.box.middleanimation.middlepositiony,
                            toolbar_props.box.middleanimation.middlewidth,value + "%",toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "lastpositionx") {
                        toolbar_props.onBoxEndAnimation(id,value + "%",toolbar_props.box.endanimation.lastpositiony,toolbar_props.box.endanimation.lastwidth,
                        toolbar_props.box.endanimation.lastheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "lastpositiony") {
                        toolbar_props.onBoxEndAnimation(id,toolbar_props.box.endanimation.lastpositionx,value + "%",toolbar_props.box.endanimation.lastwidth,
                        toolbar_props.box.endanimation.lastheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "lastwidth") {
                        toolbar_props.onBoxEndAnimation(id,toolbar_props.box.endanimation.lastpositionx,toolbar_props.box.endanimation.lastpositiony,value + "%",
                        toolbar_props.box.endanimation.lastheight,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "lastheight") {
                        toolbar_props.onBoxEndAnimation(id,toolbar_props.box.endanimation.lastpositionx,toolbar_props.box.endanimation.lastpositiony
                            ,toolbar_props.box.endanimation.lastwidth,value + "%",toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "firstopacity") {
                        toolbar_props.onBoxFinalAnimation(id,value,toolbar_props.box.finalanimation.middleopacity,toolbar_props.box.finalanimation.lastopacity
                            ,toolbar_props.box.finalanimation.firstduration,toolbar_props.box.finalanimation.middleduration,toolbar_props.box.finalanimation.lastduration,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "middleopacity") {
                        toolbar_props.onBoxFinalAnimation(id,toolbar_props.box.finalanimation.firstopacity,value,toolbar_props.box.finalanimation.lastopacity
                            ,toolbar_props.box.finalanimation.firstduration,toolbar_props.box.finalanimation.middleduration,toolbar_props.box.finalanimation.lastduration,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "lastopacity") {
                        toolbar_props.onBoxFinalAnimation(id,toolbar_props.box.finalanimation.firstopacity,toolbar_props.box.finalanimation.middleopacity,value
                            ,toolbar_props.box.finalanimation.firstduration,toolbar_props.box.finalanimation.middleduration,toolbar_props.box.finalanimation.lastduration,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "firstduration") {
                        toolbar_props.onBoxFinalAnimation(id,toolbar_props.box.finalanimation.firstopacity,toolbar_props.box.finalanimation.middleopacity,toolbar_props.box.finalanimation.lastopacity
                            ,value,toolbar_props.box.finalanimation.middleduration,toolbar_props.box.finalanimation.lastduration,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "middleduration") {
                        toolbar_props.onBoxFinalAnimation(id,toolbar_props.box.finalanimation.firstopacity,toolbar_props.box.finalanimation.middleopacity,toolbar_props.box.finalanimation.lastopacity
                            ,toolbar_props.box.finalanimation.firstduration,value,toolbar_props.box.finalanimation.lastduration,toolbar_props.box.parent,toolbar_props.box.container);
                    }

                    if (buttonKey === "lastduration") {
                        toolbar_props.onBoxFinalAnimation(id,toolbar_props.box.finalanimation.firstopacity,toolbar_props.box.finalanimation.middleopacity,toolbar_props.box.finalanimation.lastopacity
                            ,toolbar_props.box.finalanimation.firstduration,toolbar_props.box.finalanimation.middleduration,value,toolbar_props.box.parent,toolbar_props.box.container);
                    } */

        return;

        return;
      }

      if (button.type === "number") {
        // If there's any problem when parsing (NaN) -> take min value if defined; otherwise take 0
        if (
          !(
            value &&
            value.length >= 1 &&
            (value.charAt(value.length - 1) === "." ||
              value.charAt(value.length - 1) === "," ||
              value === 0)
          )
        ) {
          value = parseFloat(value) || button.min || 0;
          if (button.max !== undefined && value > button.max) {
            value = button.max;
          }
          if (button.min !== undefined && value < button.min) {
            value = button.min;
          }
        }
      }

      if (button.type === "checkbox") {
        // `inverted`: the state field holds the opposite of the toggle.
        value = button.inverted ? !!button.checked : !button.checked;
      }
      if (button.type === "radio") {
        value = button.options[value];
        if (buttonKey === "__position") {
          toolbar_props.onToolbarUpdated(id, tabKey, currentElement, "__position", value);
          let parentId = toolbar_props.box.parent;
          let containerId = toolbar_props.box.container;
          toolbar_props.onBoxMoved(id, 0, 0, value, parentId, containerId);
          if (isSortableContainer(containerId)) {
            let newHeight = parseFloat(document.getElementById(containerId).clientHeight, 10);
            toolbar_props.onSortableContainerResized(containerId, parentId, newHeight);
          }
        }
      }

      if (button.type === "image_file") {
        if (e.target.files.length === 1) {
          let file = e.target.files[0];
          let reader = new FileReader();
          reader.onload = () => {
            let img = new Image();
            let data = reader.result;
            img.onload = () => {
              let canvas = document.createElement("canvas");
              let ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, 1200, 1200);
              toolbar_props.onToolbarUpdated(
                id,
                tabKey,
                currentElement,
                buttonKey,
                canvas.toDataURL("image/jpeg")
              );
            };
            img.src = data;
          };
          reader.readAsDataURL(file);
          return;
        }
        return;
      }

      if (button.type === "select" && button.multiple === true) {
        value = button.value;
        let ind = button.value.indexOf(e);
        value = e; // [...e.target.options].filter(o => o.selected).map(o => o.value);
      }

      if (button.type === "colorOptions") {
        value = e.value;
      }
      if (button.type === "color") {
        value = e.color;
        if (!value) {
          return;
        }
      }

      if (button.type === "select_sound_provider") {
        if (value.isDelete) {
          value = button.value.filter((sound) => sound.id != value.id);
        } else {
          value = button.value.concat(value);
        }
      }

      // toolbar_props.onToolbarUpdated(id, tabKey, accordionKeys, buttonKey, value);
      if (toolbar_props.boxSelected === -1) {
        handlecanvasToolbar(buttonKey, value, accordion, toolbar_props, buttonKey);
      } else if (currentElement === "__score") {
        toolbar_props.onScoreConfig(id, buttonKey, value);
        if (!button.__defaultField) {
          toolbar_props.onToolbarUpdated(id, tabKey, "state", buttonKey, value);
        }
      } else if (currentElement === "__inputStyle") {
        // Handle input styling properties - always save to state
        toolbar_props.onToolbarUpdated(id, tabKey, "state", buttonKey, value);
      } else {
        toolbar_props.onToolbarUpdated(id, tabKey, currentElement, buttonKey, value);
      }
    },
  };
  if (button.type === "color") {
    return React.createElement(
      FormGroup,
      {
        key: button.__name,
        style: { display: button.hide ? "none" : "block" },
      },
      [
        React.createElement(FormLabel, { key: "label_" + button.__name }, button.__name),
        /* React.createElement(
                      FormControl,
                        props,
                        null
                    ),*/
        React.createElement(
          ColorPicker,
          { key: props.label, value: props.value, onChange: props.onChange },
          []
        ),
      ]
    );
  }

  if (button.options) {
    if (button.type === "colorOptions") {
      props.options = button.options;
      props.optionRenderer = this.renderOption;
      props.valueRenderer = this.renderValue;
      return React.createElement(FormGroup, { key: button.__name }, [
        React.createElement(FormLabel, { key: "label_" + button.__name }, button.__name),
        React.createElement(Select, props, null),
      ]);
    }

    if (button.type === "select") {
      if (!button.multiple) {
        button.options.map((option, index) => {
          if (!children) {
            children = [];
          }
          let label = button.labels && button.labels[index] ? button.labels[index] : option;
          children.push(
            React.createElement("option", { key: "child_" + index, value: option }, label)
          );
        });
        props.className = "select";
        props.as = "select"; // This is crucial for Bootstrap select dropdowns
        return React.createElement(
          FormGroup,
          {
            key: button.__name,
            style: { display: button.hide ? "none" : "block" },
          },
          [
            React.createElement(FormLabel, { key: "label_" + button.__name }, button.__name),
            React.createElement(
              FormControl,
              props,
              children // Pass children to render option elements
            ),
          ]
        );
      }

      props.multiple = "multiple";
      props.options = button.options;
      props.multi = true;
      props.simpleValue = true;
      props.placeholder = "No has elegido ninguna opción";
      return React.createElement(
        FormGroup,
        {
          key: button.__name,
          style: { display: button.hide ? "none" : "block" },
        },
        [
          React.createElement(FormLabel, { key: "label_" + button.__name }, button.__name),
          React.createElement(Select, props, null),
        ]
      );
    }

    if (button.type === "radio") {
      props.style = props.style
        ? { ...props.style, display: button.hide ? "none" : "block" }
        : { style: { display: button.hide ? "none" : "block" } };

      button.options.map((radio, index) => {
        if (!children) {
          children = [];
          children.push(
            React.createElement(FormLabel, { key: "radio_label_" + button.__name }, button.__name)
          );
        }
        // TODO: deprecated — disabledOptions only serves the retired mandatory
        // types (waitForSound/waitForVideo/waitForAnimation) shown on legacy
        // trainings; remove once no trainings still use them.
        const isDisabledOption = !!(
          button.disabledOptions && button.disabledOptions.indexOf(radio) !== -1
        );
        children.push(
          React.createElement(FormCheck, {
            key: `radio_${button.__name}_${index}`,
            type: "radio",
            name: button.__name,
            value: index,
            id: button.__name + radio,
            onChange: props.onChange,
            checked: button.value === button.options[index],
            disabled: isDisabledOption,
            style: isDisabledOption ? { opacity: 0.5, pointerEvents: "none" } : undefined,
            label: button.labels && button.labels[index] ? button.labels[index] : radio,
          })
        );
      });
      return React.createElement(FormGroup, props, children);
    }

    if (button.type === "fancy_radio") {
      if (buttonKey === "__verticalAlign") {
        return React.createElement(
          RadioButtonFormGroup,
          {
            key: button.__name,
            title: button.__name,
            options: button.options,
            selected: button.value,
            style: { display: button.hide ? "none" : "block" },
            click: (option) => {
              toolbar_props.onVerticallyAlignBox(toolbar_props.boxSelected, option);
            },
            tooltips: button.tooltips,
            icons: button.icons,
          },
          null
        );
      }
      return null;
    }
  }

  if (button.type === "checkbox") {
    delete props.style.width;
    return React.createElement(
      FormGroup,
      {
        key: button.__name,
        style: {
          display: button.hide ? "none" : "block",
          marginBottom: "12px",
        },
      },
      [
        <div key={buttonKey + "row"} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div className="custom-toggle-wrapper" style={{ flexShrink: 0 }}>
            {React.createElement(ToggleSwitch, { key: buttonKey + "toggle", ...props })}
          </div>
          <label
            style={{
              display: "inline-block",
              margin: 0,
              fontSize: "14px",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            {props.label}
          </label>
        </div>,
        // Optional helper line under the toggle (button.note).
        button.note ? (
          <div
            key={buttonKey + "note"}
            style={{ marginTop: "4px", fontSize: "9px", lineHeight: 1.4, color: "#6b7280" }}
          >
            {button.note}
          </div>
        ) : null,
      ]
    );
  }

  if (button.type === "conditionalText") {
    props.style.marginTop = "5px";
    props.style.marginBottom = "15px";
    props.value = accordion.buttons[buttonKey].value;
    return React.createElement(
      FormGroup,
      {
        key: button.__name,
        style: {
          display: accordion.buttons[button.associatedKey].checked ? "block" : "none",
        },
      },
      [
        button.displayName ? (
          React.createElement(FormLabel, { key: "label_" + button.__name }, button.__name)
        ) : (
          <div key="empty_label" style={{ display: "none" }}></div>
        ),
        React.createElement(
          "span",
          { key: "output_span" + button.__name, className: "rangeOutput" },
          button.actualType === "range" ? button.value : null
        ),
        React.createElement(FormControl, { key: "form_control_" + button.__name, ...props }, null),
      ]
    );
  }

  if (button.type === "image_file") {
    let isURI = /data\:/.test(props.value);
    return React.createElement(
      FormGroup,
      {
        key: button.__name,
        style: { display: button.hide ? "none" : "block" },
      },
      [
        React.createElement(
          FormLabel,
          { key: "label_" + button.__name, value: button.value },
          button.__name
        ),
        React.createElement(
          "div",
          { key: "container_" + button.__name, style: { display: "block" } },
          React.createElement(
            FileInput,
            {
              key: "fileinput_" + props.label,
              value: props.value,
              onChange: props.onChange,
              style: { width: "100%" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundImage: isURI ? "url(" + props.value + ")" : "none",
                },
                key: "inside_" + props.label,
                className: "fileDrag_toolbar",
              },
              isURI
                ? null
                : [
                    React.createElement(
                      "span",
                      { key: props.label + "1" },
                      i18n.t("FileInput.Drag")
                    ),
                    React.createElement(
                      "span",
                      { key: props.label + "2", className: "fileUploaded" },
                      [
                        React.createElement(
                          "i",
                          {
                            key: "icon_" + button.__name,
                            className: "material-icons",
                          },
                          "insert_drive_file"
                        ),
                      ]
                    ),
                  ]
            )
          )
        ),
      ]
    );
  }

  if (button.type === "external_provider") {
    let isVideo = button.accept && button.accept.includes("video");
    let isImage = button.accept && button.accept.includes("image");
    let isSound = button.accept && button.accept.includes("audio");
    let isPdf = button.accept && button.accept.includes("application/pdf");
    return React.createElement(
      ToolbarFileProvider,
      {
        id: toolbar_props.boxSelected,
        key: button.__name,
        formControlProps: props,
        openModal: (id, accept) => {
          if (isVideo && toolbar_props.onAddVideoModalToggle) {
            toolbar_props.onAddVideoModalToggle((url) => {
              props.onChange({ value: url });
            }, i18n.t("AddVideo"));
          } else if (isImage && toolbar_props.onAddImageModalToggle) {
            toolbar_props.onAddImageModalToggle((url) => {
              props.onChange({ value: url });
            }, i18n.t("AddImage"));
          } else if (isSound && toolbar_props.onAddSoundModalToggle) {
            toolbar_props.onAddSoundModalToggle((url) => {
              props.onChange({ value: url });
            }, i18n.t("AddSound"));
          } else {
            toolbar_props.openFileModal(id, accept);
          }
        },
        buttontext: isVideo
          ? i18n.t("AddVideo")
          : isImage
            ? i18n.t("AddImage")
            : isSound
              ? i18n.t("AddSound")
              : isPdf
                ? i18n.t("AddPdf")
                : i18n.t("importFile.title"),
        fileModalResult: toolbar_props.fileModalResult,
        onChange: props.onChange,
        accept: button.accept,
        hide: button.hide,
      },
      null
    );
  }

  //TODO: Deprecated external_provider_without_input
  /* if (button.type === "external_provider_without_input") {
    return React.createElement(
      ToolbarFileProviderWithoutInput,
      {
        key: button.__name,
        openModal: toolbar_props.openFileModal,
        buttontext: i18n.t("Sound.uploadSound"),
        fileModalResult: toolbar_props.fileModalResult,
        onChange: props.onChange,
        accept: button.accept,
        hide: button.hide,
      },
      null
    );
  } */

  if (button.type === "sound_recorder_provider") {
    return React.createElement(
      SoundRecorderProvider,
      {
        id: toolbar_props.navItemSelected,
        key: button.__name,
        formControlProps: props,
        hide: button.hide,
        setSoundRecorderVisible: toolbar_props.setSoundRecorderVisible,
      },
      null
    );
  }

  if (button.type === "apply_all_scenes") {
    return React.createElement(
      ApplyAllScenesProvider,
      {
        id: toolbar_props.navItemSelected,
        key: button.__name,
        formControlProps: props,
        hide: button.hide,
        setUploadTemplateVisible: toolbar_props.setUploadTemplateVisible,
      },
      null
    );
  }

  if (button.type === "add_sound") {
    if (toolbar_props.onAddSoundModalToggle) {
      return React.createElement(
        AddSoundProvider,
        {
          id: toolbar_props.navItemSelected,
          key: button.__name,
          formControlProps: props,
          hide: button.hide,
          setAddSoundVisible: () => {
            // null callback → onSoundSelected=null → scene sound adding mode
            toolbar_props.onAddSoundModalToggle(null, i18n.t("AddSound"));
          },
        },
        null
      );
    }
    return React.createElement(
      AddSoundProvider,
      {
        id: toolbar_props.navItemSelected,
        key: button.__name,
        formControlProps: props,
        hide: button.hide,
        setAddSoundVisible: toolbar_props.setAddSoundVisible,
      },
      null
    );
  }

  if (button.type === "audio_preview") {
    // display - subtitle
    return React.createElement(
      AudioPlayerProvider,
      {
        soundList: toolbar_props.pageSoundList,
        show: button.value,
      },
      null
    );
  }

  if (button.type === "sound_list") {
    return React.createElement(
      SoundListProvider,
      {
        id: toolbar_props.navItemSelected,
        boxSelected: toolbar_props.boxSelected,
        key: button.__name,
        formControlProps: props,
        hide: button.hide,
        setAddSoundVisible: toolbar_props.setAddSoundVisible,
        soundList: toolbar_props.boxSelected != -1 ? button.value : toolbar_props.pageSoundList,
        deleteSound: toolbar_props.deleteSound,
        setAddSoundVisibleWithIndex: toolbar_props.setAddSoundVisibleWithIndex,
      },
      null
    );
  }

  if (button.type === "oneclick_edit") {
    return React.createElement(
      OneClickEditProvider,
      {
        id: toolbar_props.boxSelected,
        key: button.__name,
        formControlProps: props,
        hide: button.hide,
        onOneClickEditModalToggled: toolbar_props.onOneClickEditModalToggled,
        onRichMarkEditPressed: toolbar_props.onRichMarkEditPressed,
        marks: toolbar_props.marks,
      },
      null
    );
  }

  // If it's none of previous types (number, text, color, range, ...)
  if (accordionKeys[0] === "structure" && (buttonKey === "width" || buttonKey === "height")) {
    const auto = toolbar_plugin_state.structure[buttonKey] === "auto";
    const unit = toolbar_plugin_state.structure[buttonKey + "Unit"] || "%";
    const displayValue = auto ? "" : toolbar_plugin_state.structure[buttonKey];

    return (
      <div key={button.__name} style={{ display: button.hide ? "none" : "block" }}>
        {/* Label */}
        <div
          style={{
            fontSize: "11px",
            fontWeight: 600,
            color: "#64748b",
            marginBottom: "4px",
            textTransform: "uppercase",
            letterSpacing: "0.04em",
          }}
        >
          {button.__name}
        </div>

        {/* Input field */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background: "#f1f5f9",
            borderRadius: "8px",
            padding: "4px 10px",
            border: "1px solid #e2e8f0",
          }}
        >
          <LiveNumberInput
            disabled={auto}
            value={displayValue}
            min={0}
            max={unit === "%" ? 100 : 100000}
            step={1}
            style={{
              flex: 1,
              border: "none",
              background: "transparent",
              fontWeight: 700,
              fontSize: "14px",
              color: auto ? "#94a3b8" : "#1e293b",
              width: "100%",
              outline: "none",
              textAlign: "right",
            }}
            onChange={(v) => props.onChange({ target: { value: v, type: "number" } })}
          />
          <span style={{ fontSize: "12px", color: "#94a3b8", marginLeft: "4px", fontWeight: 500 }}>
            {auto ? i18n.t("Auto") : unit}
          </span>
        </div>
      </div>
    );
  }

  // X and Y position inputs — label on top, input below, side by side (mirrors width/height layout)
  if (accordionKeys[0] === "structure" && buttonKey === "x") {
    const xValue = button.value !== undefined ? Number(button.value) : 0;
    const yValue =
      accordion.buttons.y && accordion.buttons.y.value !== undefined
        ? Number(accordion.buttons.y.value)
        : 0;
    const unit = "%";

    const colLabelStyle = {
      fontSize: "11px",
      fontWeight: 600,
      color: "#64748b",
      marginBottom: "4px",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    };
    const inputBoxStyle = {
      display: "flex",
      alignItems: "center",
      background: "#f1f5f9",
      borderRadius: "8px",
      padding: "5px 10px",
      border: "1px solid #e2e8f0",
      minWidth: 0,
    };
    const numInputStyle = {
      flex: 1,
      border: "none",
      background: "transparent",
      fontWeight: 600,
      fontSize: "14px",
      color: "#1e293b",
      width: "100%",
      outline: "none",
      textAlign: "right",
      minWidth: 0,
    };
    const unitStyle = {
      fontSize: "12px",
      color: "#94a3b8",
      marginLeft: "4px",
      fontWeight: 500,
      flexShrink: 0,
    };

    return (
      <div
        key="xy-container"
        style={{ display: "flex", gap: "8px", width: "100%", marginBottom: "4px" }}
      >
        {/* X column */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={colLabelStyle}>X</div>
          <div style={inputBoxStyle}>
            <LiveNumberInput
              value={xValue}
              min={0}
              max={100}
              step={1}
              style={numInputStyle}
              onChange={(v) => props.onChange({ target: { value: v, type: "number" } })}
            />
            <span style={unitStyle}>{unit}</span>
          </div>
        </div>
        {/* Y column */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={colLabelStyle}>Y</div>
          <div style={inputBoxStyle}>
            <LiveNumberInput
              value={yValue}
              min={0}
              max={100}
              step={1}
              style={numInputStyle}
              onChange={(v) => {
                let value = v;
                if (isNaN(parseInt(value, 10))) {
                  value = value === "" ? 0 : 100;
                } else {
                  value = parseInt(value, 10);
                }
                value = Math.min(Math.max(value, 0), 100);
                toolbar_props.onBoxMoved(
                  id,
                  toolbar_props.box.position.x,
                  Math.min(value, 100 - toolbar_plugin_state.structure.height) + "%",
                  "absolute",
                  toolbar_props.box.parent,
                  toolbar_props.box.container
                );
              }}
            />
            <span style={unitStyle}>{unit}</span>
          </div>
        </div>
      </div>
    );
  }

  // Skip Y rendering since it's already rendered with X
  if (accordionKeys[0] === "structure" && buttonKey === "y") {
    return null;
  }

  // Rotation + Flip compact icon controls
  if (accordionKeys[0] === "structure" && buttonKey === "rotation") {
    const rotationValue = normalizeRotation(button.value);
    const setRotation = (v) =>
      toolbar_props.onToolbarUpdated(id, tabKey, "structure", "rotation", normalizeRotation(v));
    const hFlipBtn = accordion.buttons.horizontalFlip;
    const vFlipBtn = accordion.buttons.verticalFlip;
    const isHFlipped = !!(hFlipBtn && hFlipBtn.checked);
    const isVFlipped = !!(vFlipBtn && vFlipBtn.checked);

    const pillStyle = {
      display: "flex",
      alignItems: "center",
      background: "#f1f5f9",
      borderRadius: "10px",
      padding: "6px 10px",
      border: "1px solid #e2e8f0",
      gap: "6px",
      flexShrink: 0,
    };
    const flipBtnBase = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "28px",
      height: "28px",
      borderRadius: "6px",
      border: "none",
      cursor: "pointer",
      padding: 0,
      flexShrink: 0,
      transition: "background 0.15s ease, color 0.15s ease",
    };

    return (
      <div
        key="rotation-flip-container"
        style={{
          display: "flex",
          gap: "8px",
          width: "100%",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {/* Rotation pill: icon + number input + stepper */}
        <div style={pillStyle}>
          <i
            className="material-icons"
            style={{ fontSize: "16px", color: "#64748b", flexShrink: 0, userSelect: "none" }}
          >
            rotate_right
          </i>
          <LiveNumberInput
            value={rotationValue}
            min={ROTATION_MIN}
            max={ROTATION_MAX}
            step={1}
            style={{
              width: "36px",
              border: "none",
              background: "transparent",
              fontWeight: 600,
              fontSize: "14px",
              color: "#1e293b",
              outline: "none",
              textAlign: "center",
              flexShrink: 0,
            }}
            onChange={setRotation}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
            <HoldRepeatButton
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "18px",
                height: "14px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: 0,
                color: "#64748b",
              }}
              onStep={() => setRotation(rotationValue + 1)}
            >
              <i className="material-icons" style={{ fontSize: "12px" }}>
                expand_less
              </i>
            </HoldRepeatButton>
            <HoldRepeatButton
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "18px",
                height: "14px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: 0,
                color: "#64748b",
              }}
              onStep={() => setRotation(rotationValue - 1)}
            >
              <i className="material-icons" style={{ fontSize: "12px" }}>
                expand_more
              </i>
            </HoldRepeatButton>
          </div>
        </div>

        {/* Flip pill: reset + flip horizontal + flip vertical */}
        <div style={pillStyle}>
          <button
            style={{ ...flipBtnBase, background: "transparent", color: "#64748b" }}
            title="Reset"
            onClick={() => {
              toolbar_props.onToolbarUpdated(id, tabKey, "structure", "rotation", 0);
              if (isHFlipped)
                toolbar_props.onToolbarUpdated(id, tabKey, "structure", "horizontalFlip", false);
              if (isVFlipped)
                toolbar_props.onToolbarUpdated(id, tabKey, "structure", "verticalFlip", false);
            }}
          >
            <i className="material-icons" style={{ fontSize: "16px" }}>
              refresh
            </i>
          </button>
          <button
            style={{
              ...flipBtnBase,
              background: isHFlipped ? "rgba(99,102,241,0.12)" : "transparent",
              color: isHFlipped ? "#6366f1" : "#64748b",
            }}
            title={i18n.t("HorizontalFlip")}
            onClick={() =>
              toolbar_props.onToolbarUpdated(id, tabKey, "structure", "horizontalFlip", !isHFlipped)
            }
          >
            <i className="material-icons" style={{ fontSize: "16px" }}>
              flip
            </i>
          </button>
          <button
            style={{
              ...flipBtnBase,
              background: isVFlipped ? "rgba(99,102,241,0.12)" : "transparent",
              color: isVFlipped ? "#6366f1" : "#64748b",
            }}
            title={i18n.t("VerticalFlip")}
            onClick={() =>
              toolbar_props.onToolbarUpdated(id, tabKey, "structure", "verticalFlip", !isVFlipped)
            }
          >
            <i
              className="material-icons"
              style={{ fontSize: "16px", display: "block", transform: "rotate(90deg)" }}
            >
              flip
            </i>
          </button>
        </div>
      </div>
    );
  }

  if (button.type === "number") {
    return (
      <div
        key={button.__name}
        style={{ display: button.hide ? "none" : "block", width: "100%", marginBottom: "4px" }}
      >
        <div
          style={{
            fontSize: "11px",
            fontWeight: 600,
            color: "#64748b",
            marginBottom: "4px",
            textTransform: "uppercase",
            letterSpacing: "0.04em",
          }}
        >
          {button.__name}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background: "#f1f5f9",
            borderRadius: "8px",
            padding: "5px 10px",
            border: "1px solid #e2e8f0",
          }}
        >
          <NumberField
            value={button.value}
            placeholder={button.placeholder}
            allowEmpty={button.allowEmpty}
            min={button.min}
            max={button.max}
            step={button.step}
            style={{
              flex: 1,
              border: "none",
              background: "transparent",
              fontWeight: 600,
              fontSize: "14px",
              color: "#1e293b",
              width: "100%",
              outline: "none",
              textAlign: "right",
              minWidth: 0,
            }}
            onCommit={(v) => props.onChange({ target: { value: v, type: "number" } })}
          />
        </div>
      </div>
    );
  }

  if (button.type === "range") {
    props.className = "rangeInput";
    props.key = "child_" + buttonKey;
    return React.createElement(
      FormGroup,
      {
        key: "range_" + buttonKey,
        style: { display: button.hide ? "none" : "block" },
      },
      [
        React.createElement(FormLabel, { key: "label_" + buttonKey }, button.__name),
        // React.createElement(
        //     "span",
        //     { key: 'output_span' + button.__name, className: 'rangeOutput' },
        //    button.type === "range" ? button.value : null),

        // React.createElement(
        //     FormControl,
        //     {
        //         ...props
        //         , display: button.hide ? 'none' : 'block'
        //         , type: "number", min: 0, max: 360, id: "page_rotation_num", step: 1
        //         , value: (button.type === "range" ? button.value : null)
        //         , key: 'output_span' + button.__name, className: 'rangeOutput'
        //         , style: { width: "64px", marginTop: "-48px" }
        //     },
        //     null),

        React.createElement(FormControl, props, null),
      ]
    );
  }
  return React.createElement(
    FormGroup,
    { key: button.__name, style: { display: button.hide ? "none" : "block" } },
    [
      React.createElement(FormLabel, { key: "label_" + button.__name }, button.__name),
      React.createElement(FormControl, props, null),
    ]
  );
}

/**
 * Renders options or multiple select inputs
 * @param option Option object wihth its label
 * @returns {code}
 */
export function renderOption(option) {
  return (
    <span>
      {option.label}
      <i style={{ color: option.color, float: "right" }} className="fa fa-stop" />
    </span>
  );
}

/**
 * Rende option value
 * @param option Option object wihth its label
 * @returns {code}
 */
export function renderValue(option) {
  return <span>{option.label}</span>;
}

/**
 * Header configuration
 * @param name type of title
 * @param value value of the field
 */
export function getMandatoryPopupState() {
  return mandatoryPopupState;
}

export function setMandatoryPopupForceUpdate(forceUpdateFn) {
  mandatoryPopupState.forceUpdate = forceUpdateFn;
}

export function renderMandatoryPopup(globalConfig) {
  if (!mandatoryPopupState.show) {
    return null;
  }

  const rawSeconds = globalConfig && Number(globalConfig.minTimeProgress);
  const seconds = Number.isFinite(rawSeconds) && rawSeconds > 0 ? rawSeconds : 3;

  return React.createElement(
    Alert,
    {
      show: mandatoryPopupState.show,
      hasHeader: false,
      acceptButtonText: i18n.t("messages.OK"),
      onClose: mandatoryPopupState.onClose,
    },
    i18n.t("error.mandatoryCompleted", { seconds })
  );
}

export function handlecanvasToolbar(name, value, accordions, toolbar_props) {
  let navitem = toolbar_props.navItems[toolbar_props.navItemSelected];
  let toolbar = accordions;
  switch (name) {
    // change page/slide title
    case "background":
      let isColor = /rgb[a]?\(\d+\,\d+\,\d+(\,[\d\.]+)?\)/.test(value);
      if (isColor) {
        toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, value);
      } else {
        toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, value);
      }
      break;
    case "pagetitle_name":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentTitleContent: value,
      });
      break;
    // change page/slide title
    case "pagesubtitle_name":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentSubtitleContent: value,
      });
      break;
    // change page/slide title
    case "pagenumber_name":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        numPageContent: value,
      });
      break;
    // preview / export document
    case "page_display":
      toolbar_props.onNavItemToggled(toolbar_props.navItemSelected);

      break;
    // change document(navitem) name
    case "navitem_name":
      // if (isContainedView(toolbar_props.navItemSelected)) {
      //     toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, { viewName: value });
      // } else {
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        viewName: value,
      });
      // }
      break;
    // display - course title
    case "navitem_autoNext":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        autoNext: value,
        // Turning auto-advance off also drops the countdown card opt-in.
        ...(value ? {} : { autoNextShowCta: false }),
      });
      break;
    case "navitem_autoNextShowCta":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        autoNextShowCta: value,
      });
      break;
    case "navitem_sceneEndCta":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        sceneEndCta: value,
      });
      break;
    case "navitem_waitForCorrectAnswer":
      // Switch toggle: ON → waitForCorrectAction, OFF → waitForAction
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        mandatoryType: value ? "waitForCorrectAction" : "waitForAction",
      });
      break;
    case "navitem_mandatoryType":
      // Eğer waitForTime seçilirse ve minTime yoksa, default 3 saniye ekle
      const currentToolbar = toolbar_props.viewToolbars[toolbar_props.navItemSelected];
      const updatePayload = { mandatoryType: value };

      if (
        value === "waitForTime" &&
        (currentToolbar.minTime === undefined || currentToolbar.minTime === null)
      ) {
        updatePayload.minTime = 3;
      }

      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, updatePayload);
      break;
    case "navitem_isMandatory":
      if (value === false) {
        mandatoryPopupState.show = true;
        mandatoryPopupState.onClose = () => {
          mandatoryPopupState.show = false;
          if (mandatoryPopupState.forceUpdate) {
            mandatoryPopupState.forceUpdate();
          }
        };
        if (mandatoryPopupState.forceUpdate) {
          mandatoryPopupState.forceUpdate();
        }
      }

      // Her durumda (true veya false) mandatoryType ve minTime setlenmeli
      const mandatoryToolbar = toolbar_props.viewToolbars[toolbar_props.navItemSelected];
      // Toggling mandatory always clears the slideDuration override so the
      // duration input starts empty (placeholder = suggested scene duration)
      // instead of resurfacing the last typed value or a batch-applied 3s.
      const mandatoryPayload = { isMandatory: value, slideDuration: null };

      if (value === false) {
        mandatoryPayload.mandatoryType = "waitForTime";
        mandatoryPayload.minTime =
          mandatoryToolbar.minTime !== undefined &&
          mandatoryToolbar.minTime !== null &&
          mandatoryToolbar.minTime > 0
            ? mandatoryToolbar.minTime
            : 3;
      }
      // isMandatory true yapılırken de minTime ve mandatoryType yoksa ekle
      else if (value === true) {
        // Imported/AI content can carry a question or one-click type on a scene
        // that has neither — fall back to waitForTime so the stale type doesn't
        // surface in the panel (e.g. "wait for correct answer" with no question).
        const presentSlice = {
          navItemsById: toolbar_props.navItems,
          containedViewsById: toolbar_props.containedViews,
          pluginToolbarsById: toolbar_props.pluginToolbars,
          exercises: toolbar_props.exercises,
        };
        const currentType = mandatoryToolbar.mandatoryType;
        const baseMissing =
          ((currentType === "waitForAction" || currentType === "waitForCorrectAction") &&
            !sceneHasQuestions(presentSlice, toolbar_props.navItemSelected)) ||
          (currentType === "waitForOneClick" &&
            !sceneHasOneClick(presentSlice, toolbar_props.navItemSelected));
        if (!currentType || baseMissing) {
          mandatoryPayload.mandatoryType = "waitForTime";
        }
        if (mandatoryToolbar.minTime === undefined || mandatoryToolbar.minTime === null) {
          mandatoryPayload.minTime = 3;
        }
      }

      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, mandatoryPayload);
      break;
    case "navitem_minTime":
      // Kept for legacy callers; new UI dispatches navitem_slideDuration below.
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        minTime: value,
      });
      break;
    case "navitem_slideDuration": {
      const numeric = Number(value);
      const cleared =
        value === "" ||
        value === null ||
        value === undefined ||
        Number.isNaN(numeric) ||
        numeric <= 0;
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        slideDuration: cleared ? null : numeric,
      });
      break;
    }
    case "audio_preview_enable":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        audio_preview_enable: value,
      });
      break;
    case "navitem_applyAllScenes":
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        applyAllScenes: value,
      });
      break;
    case "display_title":
      let courseTitle = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        courseTitle: courseTitle,
      });
      break; // display - page title
    case "display_pagetitle":
      let docTitle = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentTitle: docTitle,
      });
      break;
    // display - page title*
    /** ******************************Necesarias??******************************/
    case i18n.t("Title") + i18n.t("page"):
      let pageTitle = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentTitle: pageTitle,
      });
      break;
    // display - slide title
    case i18n.t("Title") + i18n.t("slide"):
      let slideTitle = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentTitle: slideTitle,
      });
      break;
    case i18n.t("Title") + i18n.t("section"):
      let sectionTitle = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentTitle: sectionTitle,
      });
      break;
    /** ***********************************************************************/
    // display - subtitle
    case "display_pagesubtitle":
      let subTitle = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        documentSubtitle: subTitle,
      });
      break;
    // display - breadcrumb
    case "display_breadcrumb":
      let breadcrumb = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        breadcrumb: breadcrumb,
      });
      break;
    // display - pagenumber
    case "display_pagenumber":
      let pagenumber = value ? "reduced" : "hidden";
      toolbar_props.updateViewToolbar(toolbar_props.navItemSelected, {
        numPage: pagenumber,
      });
      break;
    case "weight":
      toolbar_props.onScoreConfig(toolbar_props.navItemSelected, "weight", value);
      break;
    default:
      break;
  }
}

/* eslint-enable react/prop-types */
